import { subDays, subMonths, format, startOfMonth, endOfMonth } from 'date-fns';

export default {
  data() {
    return {
      widgetList: [
        {
          name: 'daily_shipments',
          title: 'Daily Shipments',
          iconClass: 'fa fa-bar-chart',
          minW: 6,
          minH: 8,
          options: [
            { type: 'date_range', name: 'Date Range' },
          ],
        },
        {
          name: 'daily_orders',
          title: 'Daily Orders',
          iconClass: 'fa fa-line-chart',
          minW: 6,
          minH: 8,
          options: [
            { type: 'date_range', name: 'Date Range' },
          ],
        },
        {
          name: 'shipment_by_state',
          title: 'Shipment By State',
          iconClass: 'fa fa-pie-chart',
          minW: 6,
          minH: 12,
          options: [
            { type: 'date_range', name: 'Date Range' },
          ],
        },
        // {
        //   name: 'completion_items',
        //   title: 'Shipment Completion',
        //   iconClass: 'fa fa-truck',
        //   minW: 12,
        //   minH: 14,
        //   options: [],
        // },
        {
          name: 'vehicle_status',
          title: 'Vehicle Status',
          iconClass: 'fa fa-car',
          minW: 6,
          minH: 12,
          options: [
            { type: 'geofences', name: 'Geofences' },
          ],
        },
        {
          name: 'orders_cancelation',
          title: 'Orders Cancellation',
          iconClass: 'fa fa-cube',
          minW: 6,
          minH: 12,
          options: [
            { type: 'date_range', name: 'Date Range' },
          ],
        },
      ],
      defaultWidgets: [
        {
          name: 'completion_items',
          title: 'Completion',
          iconClass: 'fa fa-truck',
          x: 0,
          y: 0,
          w: 12,
          h: 14,
          minW: 12,
          minH: 14,
          i: '0',
          options: [],
        },
        {
          date_range: 'this_month',
          title: 'Daily Shipment',
          name: 'daily_shipments',
          iconClass: 'fa fa-bar-chart',
          x: 0,
          y: 14,
          w: 6,
          h: 8,
          minW: 6,
          minH: 8,
          i: '1',
          options: [
            { type: 'date_range', name: 'Date Range' },
          ],
        },
        {
          date_range: 'this_month',
          title: 'Daily Orders',
          name: 'daily_orders',
          iconClass: 'fa fa-line-chart',
          x: 6,
          y: 14,
          w: 6,
          h: 8,
          minW: 6,
          minH: 8,
          i: '2',
          options: [
            { type: 'date_range', name: 'Date Range' },
          ],
        },
        {
          date_range: 'this_month',
          title: 'Shipment By State',
          name: 'shipment_by_state',
          iconClass: 'fa fa-pie-chart',
          x: 0,
          y: 22,
          w: 6,
          h: 12,
          minW: 6,
          minH: 12,
          i: '3',
          options: [
            { type: 'date_range', name: 'Date Range' },
          ],
        },
      ],
      presetsDaterange: [
        { id: 0, value: 'today', name: 'Today' },
        { id: 1, value: 'yesterday', name: 'Yesterday' },
        { id: 2, value: 'last_7_days', name: 'Last 7 Days' },
        { id: 3, value: 'last_30_days', name: 'Last 30 Days' },
        { id: 4, value: 'this_month', name: 'This Month' },
        { id: 5, value: 'last_month', name: 'Last Month' },
        { id: 6, value: 'last_3_month', name: 'Last 3 Month' },
        { id: 7, value: 'custom', name: 'Custom' },
      ],
    };
  },
  methods: {
    updateRange(daterange) {
      const formatDate = 'YYYY-MM-DD';
      let start_date;
      let end_date;

      switch (daterange) {
        case 'today':
          start_date = format(new Date(), formatDate);
          end_date = format(new Date(), formatDate);
          break;
        case 'yesterday':
          start_date = format(subDays(new Date(), 1), formatDate);
          end_date = format(subDays(new Date(), 1), formatDate);
          break;
        case 'last_7_days':
          start_date = format(subDays(new Date(), 7), formatDate);
          end_date = format(subDays(new Date(), 1), formatDate);
          break;
        case 'last_30_days':
          start_date = format(subDays(new Date(), 30), formatDate);
          end_date = format(subDays(new Date(), 1), formatDate);
          break;
        case 'this_month':
          start_date = format(startOfMonth(new Date()), formatDate);
          end_date = format(endOfMonth(new Date()), formatDate);
          break;
        case 'last_month':
          start_date = format(startOfMonth(subMonths(new Date(), 1)), formatDate);
          end_date = format(endOfMonth(subMonths(new Date(), 1)), formatDate);
          break;
        case 'last_3_month':
          start_date = format(startOfMonth(subMonths(new Date(), 3)), formatDate);
          end_date = format(endOfMonth(subMonths(new Date(), 1)), formatDate);
          break;
        default:
          return null;
      }

      return {
        start_date,
        end_date,
      };
    },
    parsePreference(target, parseMode = 'toJSON') {
      let newFormat = target;
      if (parseMode === 'toJSON') {
        newFormat = JSON.parse(newFormat.replace(new RegExp("'", 'g'), '"'));
      } else if (parseMode === 'toString') {
        newFormat = JSON.stringify(newFormat).replace(new RegExp('"', 'g'), "'");
      }

      return newFormat;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/dashboard.js